/**
 * Reviews Page CTA Click Tracking
 * Fires events to GA4 (dataLayer) + Shopify analytics
 */
(function() {
  'use strict';

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-track]');
    if (!btn) return;

    var trackId = btn.getAttribute('data-track');
    var variantId = btn.getAttribute('data-variant-id') || '';
    var btnText = btn.textContent.trim();

    // GA4 dataLayer event
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'reviews_cta_click',
      cta_location: trackId,
      cta_text: btnText,
      variant_id: variantId,
      page: window.location.pathname
    });

    // Shopify analytics (if available)
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib) {
      window.ShopifyAnalytics.lib.track('Reviews CTA Click', {
        location: trackId,
        text: btnText,
        variant_id: variantId
      });
    }

    // Console log for debugging (remove in production if desired)
    console.log('[Reviews Tracking]', trackId, btnText, variantId);
  });
})();
